// import gsap
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".block-tab-start");
  // Nav containers that share the staggered "tabs slide up" entrance:
  // the collection/education nav and the search results filter tabs.
  const navContainers = document.querySelectorAll(".nav-collection, .search-page__tabs");

  // Check if we're on a single page or archive page
  const isSinglePage =
    document.body.classList.contains("single") || document.body.classList.contains("single-post") || document.body.classList.contains("single-page");
  const isArchivePage = document.body.classList.contains("archive");

  // Store ScrollTrigger instances for later refresh
  let scrollTriggers = [];

  // Function to refresh ScrollTrigger animations
  function refreshScrollTriggers() {
    ScrollTrigger.refresh();

    // Force a small delay to ensure DOM updates are complete
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);
  }

  // Function to create tab animations
  function createTabAnimations() {
    // Clear any existing ScrollTrigger instances
    scrollTriggers.forEach((trigger) => trigger.kill());
    scrollTriggers = [];

    // Set initial state for all tabs
    tabs.forEach((tab) => {
      // Skip accordion elements to prevent conflicts
      if (tab.closest(".accordion")) return;

      gsap.set(tab, {
        scale: 1,
        y: 0,
        opacity: 1,
        rotation: 0, // Start with no tilt
      });
    });

    // Create the scaling animation for tabs
    tabs.forEach((tab, index) => {
      // Skip accordion elements to prevent conflicts
      if (tab.closest(".accordion")) return;

      // Skip animation for the first tab on single pages or archive pages
      if (index === 0 && (isSinglePage || isArchivePage)) return;

      // Main entrance animation
      const mainAnimation = gsap.to(tab, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: tab,
          start: "top 50%", // Scale to normal size when tab is 50% from bottom
          end: "top -20%", // End later - extend beyond the top
          scrub: 1.5, // Longer scrub for extended animation
          // markers: true,
        },
      });

      // Store the ScrollTrigger instance
      if (mainAnimation.scrollTrigger) {
        scrollTriggers.push(mainAnimation.scrollTrigger);
      }

      // Scale animation for previous tab when this tab comes into view
      if (index > 0) {
        const previousTab = tabs[index - 1];

        // Skip if previous tab is the first tab or is an accordion element
        if (index === 1 && (isSinglePage || isArchivePage)) return;
        if (previousTab.closest(".accordion")) return;

        // Scale and parallax effect for previous tab
        const previousAnimation = gsap.to(previousTab, {
          scale: 0.9,
          y: 400, // Move up slightly to create depth
          rotation: 0.1, // Very subtle tilt during animation
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: tab,
            start: "top 50%", // Start later - when tab is 40% from bottom
            end: "top -20%", // End later - extend beyond the top
            scrub: 1.5, // Longer scrub for extended animation
          },
        });

        // Store the ScrollTrigger instance
        if (previousAnimation.scrollTrigger) {
          scrollTriggers.push(previousAnimation.scrollTrigger);
        }
      }
    });

    // Create navigation animations
    navContainers.forEach((nav) => {
      const navItems = nav.querySelectorAll("ul li, .search-page__tab");

      navItems.forEach((tabNav, index) => {
        // Skip accordion elements to prevent conflicts
        if (tabNav.closest(".accordion")) return;

        // The first tab is immediately visible; the rest slide up into place.
        if (index === 0) {
          gsap.set(tabNav, {
            y: 0,
            opacity: 1,
          });
          return;
        }

        // Set initial state
        gsap.set(tabNav, {
          y: 288,
          opacity: 0,
        });

        gsap.to(tabNav, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          delay: (index - 1) * 0.05,
        });
      });
    });
  }

  // Initialize animations
  createTabAnimations();

  // Listen for accordion changes to refresh animations
  document.addEventListener("accordionChanged", function () {
    // Wait a bit for accordion animation to complete
    setTimeout(refreshScrollTriggers, 400);
  });

  // Also refresh on window resize
  window.addEventListener("resize", function () {
    // Debounce resize events
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(refreshScrollTriggers, 250);
  });

  // Refresh animations after a delay to ensure everything is loaded
  setTimeout(refreshScrollTriggers, 500);
});
